"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _maxBy = _interopRequireDefault(require("lodash/maxBy"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _colors = require("../../constants/colors");

var _chartDisplayTypes = require("../../constants/chartDisplayTypes");

var _Styles = require("./Styles");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ClickableHint = (0, _styled["default"])(_reactVis.Hint)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  pointer-events: auto;\n"])));
var crosshairStyles = {
  line: {
    background: 'none',
    border: 'none',
    borderLeft: "1px dashed ".concat(_colors.FADED_GREY)
  },
  box: {
    display: 'none'
  }
};

var CustomerInteraction = function CustomerInteraction(_ref) {
  var chartType = _ref.chartType,
      groupedCoordinates = _ref.groupedCoordinates,
      roundedMaxValue = _ref.roundedMaxValue,
      renderHint = _ref.renderHint;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCoordinate = _useState2[0],
      setSelectedCoordinate = _useState2[1];

  var maxSelectedCoordinate = selectedCoordinate ? (0, _maxBy["default"])(selectedCoordinate.coordinates, 'y') : {
    x: 0,
    y: 0,
    y0: 0
  };
  return /*#__PURE__*/_react["default"].createElement(_Styles.FillAvailableSpace, null, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    margin: {
      left: 0,
      right: 0,
      bottom: 60,
      top: 60
    },
    xType: "ordinal",
    yDomain: [0, roundedMaxValue],
    onMouseLeave: function onMouseLeave() {
      setSelectedCoordinate(null);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    color: 'none',
    data: groupedCoordinates,
    onNearestX: function onNearestX(value) {
      setSelectedCoordinate(value);
    },
    style: {
      cursor: 'pointer',
      strokeWidth: 0
    }
  }), selectedCoordinate && /*#__PURE__*/_react["default"].createElement(_reactVis.Crosshair, {
    values: [selectedCoordinate],
    style: crosshairStyles
  }), selectedCoordinate && chartType === _chartDisplayTypes.LINE && selectedCoordinate.coordinates.map(function (hoverValue) {
    return /*#__PURE__*/_react["default"].createElement(_reactVis.MarkSeries, {
      size: 4,
      fill: 'white',
      stroke: hoverValue.color,
      style: {
        pointerEvents: 'none'
      },
      data: [hoverValue]
    });
  }), selectedCoordinate && maxSelectedCoordinate.y !== 0 && /*#__PURE__*/_react["default"].createElement(ClickableHint, {
    align: {
      vertical: 'auto',
      horizontal: 'auto'
    },
    marginLeft: 10,
    marginRight: 10,
    value: maxSelectedCoordinate
  }, renderHint && renderHint(selectedCoordinate, groupedCoordinates))));
};

CustomerInteraction.propTypes = {
  chartType: _propTypes["default"].oneOf([_chartDisplayTypes.LINE, _chartDisplayTypes.BAR]).isRequired,
  renderHint: _propTypes["default"].func,
  groupedCoordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  roundedMaxValue: _propTypes["default"].number.isRequired
};
CustomerInteraction.defaultProps = {
  renderHint: null
};
var _default = CustomerInteraction;
exports["default"] = _default;